import { TFunction } from 'i18next';
import {
    DepartmentVariableTemplateSection,
    DepartmentVariableTemplateItem,
} from '../../../services/api/departmentVariablesService';
import { VariableDefault, VariableSection } from './variableTypes';

function mapField(v: DepartmentVariableTemplateItem): 'text' | 'number' | 'ref' {
    if (v.field === 'ref') return 'ref';
    if (v.field === 'number') return 'number';
    return 'text';
}

export function hydrateTemplate(
    raw: DepartmentVariableTemplateSection[],
    t: TFunction
): VariableSection[] {
    return raw.map((section) => ({
        key: section.key,
        title: t(`departmentVariables.sections.${section.key}.title`, section.key),
        description: t(`departmentVariables.sections.${section.key}.description`, ''),
        variables: section.variables.map((v): VariableDefault => {
            const label = t(`departmentVariables.variables.${v.name}.label`, v.name);
            const placeholder = t(`departmentVariables.variables.${v.name}.placeholder`, '') || undefined;
            const field = mapField(v);

            if (field === 'ref') {
                return {
                    field: 'ref',
                    name: v.name,
                    label,
                    refTarget: v.refTarget ?? 'User.name',
                    required: v.required,
                };
            }

            return {
                field,
                name: v.name,
                label,
                placeholder,
                required: v.required,
            };
        }),
    }));
}
